import { Stack } from '@mui/material';
import { PromptLibraryIcon } from '../PromptLibraryIcon';
import { Button, colors, Typography } from '@sweep-io/sweep-design';
import { usePrompt } from '../usePrompt';

export const SinglePromptTitleLayout = ({
  iconName,
  title,
  description,
  groupId,
}: {
  iconName?: string;
  title: string;
  description?: string;
  groupId: string;
}) => {
  const { addEmptyPrompt } = usePrompt();
  return (
    <Stack direction="row" alignItems="baseline" justifyContent="space-between">
      <Stack>
        <Stack
          direction="row"
          alignItems="center"
          gap={1}
          pb={2}
          sx={{ svg: { width: '24px', height: '24px' } }}
        >
          {iconName && <PromptLibraryIcon icon={iconName} />}
          <Typography variant="h1" whiteSpace="break-spaces" wordBreak="break-word">
            {title}
          </Typography>
        </Stack>
        {description && (
          <Stack pb={2}>
            <Typography variant="h4" color={colors.grey[700]}>
              {description}
            </Typography>
          </Stack>
        )}
      </Stack>

      <Stack sx={{ button: { whiteSpace: 'nowrap' } }}>
        <Button variant="secondary" startIconName="Plus" onClick={() => addEmptyPrompt(groupId)}>
          New prompt
        </Button>
      </Stack>
    </Stack>
  );
};
